var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "TabelHeaderForNewOrder-Outsourced" },
    [
      _c(
        "el-form",
        {
          ref: "formData",
          staticClass: "formData",
          attrs: {
            rules: _vm.Rules,
            inline: true,
            model: _vm.formData,
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("TabelHeader.vendor"),
                prop: "VENDOR_CODE"
              }
            },
            [
              !_vm.userInfo.VENDOR_CODE
                ? [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请输入代码或名称",
                          filterable: "",
                          remote: "",
                          "remote-method": _vm.handleInputVendorSelect,
                          loading: _vm.selectLoading,
                          clearable: ""
                        },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.formData.VENDOR_CODE,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "VENDOR_CODE", $$v)
                          },
                          expression: "formData.VENDOR_CODE"
                        }
                      },
                      _vm._l(_vm.vendorOptions, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "changeVendorBtn",
                        on: { click: _vm.handleChangeVendorBtn }
                      },
                      [_vm._v("...")]
                    )
                  ]
                : [
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.formData.VENDOR_NAME,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "VENDOR_NAME", $$v)
                        },
                        expression: "formData.VENDOR_NAME"
                      }
                    })
                  ]
            ],
            2
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("TabelHeader.DELIVERY_DATE"),
                prop: "DELIVERY_DATE"
              }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  "default-time": _vm.defaultTime,
                  type: "date",
                  placeholder: "选择日期",
                  "value-format": "yyyy-MM-dd HH:mm:ss"
                },
                on: { change: _vm.handleDay },
                model: {
                  value: _vm.formData.DELIVERY_DATE,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "DELIVERY_DATE", $$v)
                  },
                  expression: "formData.DELIVERY_DATE"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("TabelHeader.ARRIVAL_DATE"),
                prop: "ARRIVAL_DATE"
              }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  "default-time": _vm.defaultTime,
                  type: "date",
                  placeholder: "选择日期",
                  "value-format": "yyyy-MM-dd HH:mm:ss"
                },
                on: { change: _vm.handleARRIVAL_DATE },
                model: {
                  value: _vm.formData.ARRIVAL_DATE,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "ARRIVAL_DATE", $$v)
                  },
                  expression: "formData.ARRIVAL_DATE"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "remark",
              attrs: { label: _vm.$t("TabelHeader.remark") }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.formData.DESCRIPTION,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "DESCRIPTION", $$v)
                  },
                  expression: "formData.DESCRIPTION"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("TabelHeader.CREATORID") } },
            [
              _c("span", { staticClass: "showItemName" }, [
                _vm._v(_vm._s(_vm.CREATORID))
              ])
            ]
          )
        ],
        1
      ),
      _c("changeVendorDialog", {
        ref: "changeVendorDialog",
        attrs: {
          isShowOutsourcedChangeVendorDialog:
            _vm.isShowOutsourcedChangeVendorDialog
        },
        on: {
          cbDialogSubmit: _vm.cbDialogSubmit,
          closeChangeVendorDialog: _vm.closeChangeVendorDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }